import React from 'react';
import { Box } from '@mui/material';
import SmpEmployeeSearch from './SmpEmployeeSearch';

const EmployeeSearch: React.FC = () => {
  return (
    <Box>
      <SmpEmployeeSearch />
    </Box>
  );
};

export default EmployeeSearch;
